import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeQuotationCreate,
  detail: routeQuotationDetail,
  home: routeQuotationsHome,
  root: routeQuotationsRoot,
} = createDoctypeRoutes({
  createName: 'new-quotation',
  createPath: 'new-quotation',
  detailName: 'quotation-detail',
  doctype: DOCTYPES.QUOTATION,
  homeName: 'quotations',
  path: 'quotations',
  views: {
    create: async () => await import('@/components/viewsExternal/quotations/AddQuotation.vue'),
    detail: async () => await import('@/components/viewsExternal/quotations/ViewQuotation.vue'),
    list: async () => await import('@/components/viewsExternal/quotations/QuotationView.vue'),
  },
})

export { routeQuotationCreate, routeQuotationDetail, routeQuotationsHome, routeQuotationsRoot }
